import React, { useEffect, useState } from "react";
import axios from "axios";
import { API, completaRientro, annullaRientro } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Clock } from "lucide-react";

// Sprint CONCORRENZA — rientro sopra la pagina: i dati a schermo non si perdono.
export default function SessioneScaduta() {
  const [stato, setStato] = useState(null); // { motivo, email }
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errore, setErrore] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const apri = (e) => { setStato(e.detail); setEmail(e.detail.email || ""); setPassword(""); setErrore(""); };
    window.addEventListener("kargest:sessione-scaduta", apri);
    return () => window.removeEventListener("kargest:sessione-scaduta", apri);
  }, []);

  if (!stato) return null;
  const stessoUtente = email.trim().toLowerCase() === (stato.email || "").toLowerCase();

  const rientra = async (e) => {
    e.preventDefault();
    setBusy(true); setErrore("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email: email.trim(), password });
      localStorage.setItem("dms_token", data.access_token || data.token);
      if (data.refresh_token) localStorage.setItem("dms_refresh", data.refresh_token);
      localStorage.setItem("dms_user", JSON.stringify(data.user));
      if (!stessoUtente) {
        // altro utente: nessuna richiesta riparte a suo nome, pagina pulita
        annullaRientro();
        window.location.reload();
        return;
      }
      setStato(null);
      completaRientro(data.access_token || data.token);
    } catch (err) {
      setErrore(err?.response?.data?.detail || "Accesso non riuscito");
    } finally { setBusy(false); }
  };

  const esci = () => {
    ["dms_token", "dms_refresh", "dms_user"].forEach((k) => localStorage.removeItem(k));
    annullaRientro();
    window.location.href = "/login";
  };

  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="max-w-md [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()} data-testid="sessione-scaduta-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Clock className="h-5 w-5 text-amber-600" />
            {stato.motivo === "inattivita" ? "Sessione scaduta per inattività" : "Sessione non più valida"}
          </DialogTitle>
          <DialogDescription data-testid="sessione-scaduta-messaggio">
            {stato.motivo === "inattivita"
              ? "Sei rimasto inattivo per più di 12 ore. Inserisci la password per rientrare: quello che hai sullo schermo resta com'è e l'operazione in corso riprende da sola."
              : "Il tuo accesso non è più valido. Inserisci la password per rientrare: quello che hai sullo schermo resta com'è."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={rientra} method="post" action="/login" className="space-y-3" data-testid="sessione-scaduta-form">
          <div>
            <Label htmlFor="rientro-email">Email</Label>
            <Input id="rientro-email" name="username" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="sessione-scaduta-email" />
            {!stessoUtente && (
              <p className="text-xs text-amber-700 mt-1" data-testid="sessione-scaduta-altro-utente">
                Utente diverso: la pagina verrà ricaricata e le modifiche non salvate andranno perse.
              </p>
            )}
          </div>
          <div>
            <Label htmlFor="rientro-password">Password</Label>
            <Input id="rientro-password" name="password" type="password" autoComplete="current-password" autoFocus value={password}
              onChange={(e) => setPassword(e.target.value)} data-testid="sessione-scaduta-password" />
          </div>
          {errore && <p className="text-sm text-red-600" data-testid="sessione-scaduta-errore">{errore}</p>}
          <div className="flex justify-between pt-1">
            <Button type="button" variant="ghost" onClick={esci} data-testid="sessione-scaduta-esci">Esci</Button>
            <Button type="submit" disabled={busy || !password} data-testid="sessione-scaduta-rientra">Rientra</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
